import { BuzerIcon } from "../../../BuzerIcons";

// Badge grid — state read from tint + opacity, not placeholders. Each badge:
// { code?, name, icon, earned }. `icon` is a BuzerIcon name; locked badges show
// a lock corner. onPick(b) makes them tappable.
export function Badge({ name, icon = "trophy", earned = false, onClick, "data-tour": dataTour }) {
  const cls = `bz-badge ${earned ? "bz-badge--earned" : "bz-badge--locked"}`;
  const Tag = onClick ? "button" : "div";
  return (
    <Tag type={onClick ? "button" : undefined} onClick={onClick} className={cls} data-tour={dataTour}
      style={onClick ? { font: "inherit", cursor: "pointer" } : undefined}>
      <span className="bz-badge__ic">
        <BuzerIcon name={earned ? icon : icon} size={22} color="currentColor" />
      </span>
      <span className="bz-badge__name">{name}</span>
      {!earned && <span className="bz-badge__lock"><BuzerIcon name="lock" size={13} color="currentColor" /></span>}
    </Tag>
  );
}

export function BadgeGrid({ badges = [], onPick, className = "", style }) {
  if (!badges.length) return null;
  return (
    <div className={`bz-badges ${className}`.trim()} style={style}>
      {badges.map((b, i) => (
        <Badge key={b.code || i} name={b.name} icon={b.icon} earned={b.earned}
          onClick={onPick ? () => onPick(b) : undefined} />
      ))}
    </div>
  );
}
